<template>
  <!--基本信息的基本姓名区 -->
  <!-- acCardStudentCodeType//考号填写模式：0-填涂考号， 1-条码 ，2-手写考号 -->
  <div
    class="basics_info red_info"
    :class="{ 'third-grow-info': answerSheet.acCardPanes == 3 }"
    @mouseover="showBasicsInfoEdit = true"
    @mouseleave="showBasicsInfoEdit = false"
  >
    <div
      class="basics_info_edit"
      @click="handleBasicsEdit"
      v-if="showBasicsInfoEdit"
    >
      <i class="el-icon-edit-outline" style="font-size: 18px; color: #fff"></i>
    </div>
    <div
      v-if="answerSheet.acCardPanes != 3"
      style="height: 100%; width: 100%"
    >
      <div
        class="basics-info mutile-info"
        style="padding: 5px 0px 7px 0"
        v-if="
          answerSheet.acCardStudentCodeType == 0 &&
          basicsCheckList &&
          basicsCheckList.length > 4
        "
      >
        <div class="substudentItemContainer" style="padding-bottom: 8px">
          <div
            v-if="basicsCheckList && basicsCheckList[0]"
            class="substudentItem"
            style="padding-right: 0px"
          >
            <div class="substudentItem-class">{{ basicsCheckList[0] }}</div>
            <div class="substudentItem-area"></div>
          </div>
          <div
            v-if="basicsCheckList && basicsCheckList[1]"
            class="substudentItem"
            style="margin-left: -5px"
          >
            <div class="substudentItem-class">{{ basicsCheckList[1] }}</div>
            <div class="substudentItem-area"></div>
          </div>
        </div>
        <div
          v-if="basicsCheckList && basicsCheckList[2]"
          class="substudentItem"
          style="padding-right: 0px"
        >
          <div class="substudentItem-class">{{ basicsCheckList[2] }}</div>
          <div class="substudentItem-area"></div>
        </div>
        <div
          v-if="basicsCheckList && basicsCheckList[3]"
          class="substudentItem"
          style="padding-right: 0px"
        >
          <div class="substudentItem-class">{{ basicsCheckList[3] }}</div>
          <div class="substudentItem-area"></div>
        </div>
        <div
          v-if="basicsCheckList && basicsCheckList[4]"
          class="substudentItem"
          style="padding-right: 8px"
        >
          <div class="substudentItem-class">{{ basicsCheckList[4] }}</div>
          <div class="substudentItem-area"></div>
        </div>
      </div>
      <div
        class="basics-info"
        v-else-if="
          answerSheet.acCardStudentCodeType == 0 &&
          basicsCheckList &&
          basicsCheckList.length <= 4
        "
      >
        <div class="i-name">{{ basicsCheckList[0] }}</div>
        <div class="i-cont" style="border-right: 0; flex-grow: 0.45"></div>
        <div class="i-name">{{ basicsCheckList[1] }}</div>
        <div class="i-cont" style="border-right: 0; flex-grow: 0.45"></div>
        <div class="basics-info">
          <div class="i-name">{{ basicsCheckList[2] }}</div>
          <div
            class="i-cont"
            style="border-right: 0; flex-grow: 0.45"
            v-if="basicsCheckList[2]"
          ></div>
          <div class="i-name">{{ basicsCheckList[3] }}</div>
          <div
            class="i-cont"
            style="border-right: 0; flex-grow: 0.45"
            v-if="basicsCheckList[3]"
          ></div>
        </div>
      </div>
      <div class="basics-info" v-else>
        <div
          style="display: flex"
          v-for="(item, index) in basicsCheckList"
          :key="index"
        >
          <div class="i-name">{{ item }}</div>
          <div class="i-cont"></div>
        </div>
      </div>
    </div>
    <template v-else>
      <div
        class="basics-info-left"
        :class="{'mutile-left': answerSheet.acCardPanes == 3}"
        v-if="
          answerSheet.acCardStudentCodeType === 0 ||
          answerSheet.acCardStudentCodeType === 1
        "
      >
        <div
          class="i-item"
          style="justify-content: start; margin-left: 14px; margin-top: 22px"
          v-for="(item, index) in basicsCheckList"
          :key="index"
        >
          <div class="i-name">{{ item }}</div>
          <div class="i-cont" style="flex-grow: 0.8"></div>
        </div>
        <!-- <div
          class="i-item"
          style="justify-content: start; margin-left: 14px; margin-top: 22px"
        >
          <div class="i-name">学校</div>
          <div class="i-cont" style="flex-grow: 0.8"></div>
        </div>
        <div
          class="i-item"
          style="justify-content: start; margin-left: 14px; margin-top: 22px"
        >
          <div class="i-name">班级</div>
          <div class="i-cont" style="flex-grow: 0.8"></div>
        </div>
        <div
          class="i-item"
          style="justify-content: start; margin-left: 14px; margin-top: 22px"
        >
          <div class="i-name">考号</div>
          <div class="i-cont" style="flex-grow: 0.8"></div>
        </div> -->
      </div>
      <div class="basics-info" v-else>
        <div
          v-if="false"
          style="display: flex"
          v-for="(item, index) in basicsCheckList"
          :key="index"
        >
          <div class="i-name">{{ item }}</div>
          <div
            class="i-cont"
            :style="`min-width: ${
              basicsCheckList && basicsCheckList.length == 4 ? '75px' : '90px'
            }`"
          ></div>
        </div>
        <div v-for="(item, index) in basicsCheckList" :key="index">
          <div class="substudentItemContainer" v-if="index == 0 || index == 1">
            <div
              v-if="index == 0"
              class="substudentItem"
              style="padding-right: 0px"
            >
              <div class="substudentItem-class">{{ item }}</div>
              <div class="substudentItem-area"></div>
            </div>
            <div
              v-if="index == 1"
              class="substudentItem"
              style="margin-left: -5px"
            >
              <div class="substudentItem-class">>{{ item }}</div>
              <div class="substudentItem-area"></div>
            </div>
          </div>
          <div v-else class="substudentItem">
            <div class="substudentItem-class">{{ item }}</div>
            <div class="substudentItem-area"></div>
          </div>
        </div>
      </div>
    </template>
    <ModalBasicsEdit v-model="modalBasicsEditV" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import ModalBasicsEdit from "../../views/components/card/modal-basics-info";
//基础信息区
export default {
  name: "basicsInfo",
  props: {},
  components: {
    ModalBasicsEdit,
  },
  computed: {
    ...mapGetters({
      answerSheet: "answerPanel/answerSheet",
    }),
    ...mapState("card", {
      basicsCheckList: (state) => state.basicsCheckList, //选中的信息
    }),
    // oneTwoBasicsCheckList() {
    //   return this.basicsCheckList.splice(0,2);
    // },
    // threeFourBasicsCheckList() {
    //   return this.basicsCheckList.splice(3, 4)
    // },
    contW() {
      let w;
      if (this.answerSheet.acCardStudentCodeType == 1) {
        w = this.pageCellSize[1] - 300 - 1 - 41 - 20;
      } else {
        w =
          this.pageCellSize[1] -
          this.answerSheet.acCardExamNumber * 28 -
          41 -
          20;
      }
      return w;
    },
  },
  data() {
    return {
      modalBasicsEditV: false,
      showBasicsInfoEdit: false,
      tips: []
    };
  },
  mounted(){
    // this.setUpTips()
  },
  methods: {
    setUpTips() {
      this.tips = [
        {
          pre: "答题前，考生务必认真核准条形码上的个人信息是否无误，并将核准后的条形码粘贴在指定区域，然后将",
          middle: "",
          end: "",
        },
        {
          pre: "答选择题时，必须使用 ",
          middle: " 2B 铅笔",
          end: "涂答题卡上相应题目的答案标号，修改时，要用橡皮擦干净，再选择填涂其他答案",
        },
        {
          pre: "答非选择题时，必须使用",
          middle: " 0.5 毫黑色签字笔，",
          end: "在题号所指示的答题区域内书写作效。要求字体工整，笔迹清晰。答案超出答题区域书写的答案无效，要求字体工整，笔记清晰",
        },
        {
          pre: "须保持答题卡清洁、完整，严禁折叠，严禁做任何标记，严禁使用涂改液、修正带",
          middle: "",
          end: "",
        },
      ];
    },
    handleBasicsEdit() {
      this.modalBasicsEditV = true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss" scoped>
.basics_info {
  display: flex;
  flex-flow: row wrap;
  background: #fff;
  justify-content: flex-start;
  min-width: 264px;
  width: 100%;
  position: relative;
  border-color: var(--card-color);
  border-bottom: none;
  position: relative;
  box-sizing: border-box;
  .box {
    flex: 1;
  }
  .i-name {
    // background: #f2f2f2;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    // border-right: 1px solid #000000;
    position: relative;
    font-weight: 700;
    // color: var(--card-color);
  }
  .i-cont {
    border-bottom: 1px solid #000;
    min-width: 90px;
    flex-grow: 0.26;
    margin-left: 6px;
    margin-bottom: 6px;
    &:last-child {
      border-right: 0;
    }
  }
  &.third-grow-info {
    .basics-info-left {
      &.mutile-left {
        .i-item{
        margin-top: 4px !important;
      }
      }
 
    }

  }
}

.basics-info-left {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .box {
    flex: 1;
  }
  .i-item {
    display: flex;
    justify-content: center;
  }
  .i-name {
    // background: #f2f2f2;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    // border-right: 1px solid #000000;
    position: relative;
    // color: var(--card-color);
  }
  .i-cont {
    border-bottom: 1px solid #000;
    min-width: 90px;
    flex-grow: 0.5;
    margin-left: 2px;
    margin-bottom: 8px;
    &:last-child {
      border-right: 0;
    }
  }
}

.basics_info_edit {
  position: absolute;
  display: flex;
  width: 30px;
  height: 30px;
  top: 7px;
  right: 7px;
  background: #409eff;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  box-shadow: 2px 2px 6px #3031339e;
  cursor: pointer;
  z-index: 1;
}
.red_info {
  border: 1px solid var(--card-color) !important;
  .i-cont {
    border-bottom: 1px solid var(--card-color) !important;
  }
}

.substudentItemContainer {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.substudentItem {
  font-size: 13px;
  flex: 1;
  display: flex;
  padding-left: 10px;
  padding-right: 10px;
  min-height: 26px;
  max-height: 35px;
  color: var(--card-color);
  .substudentItem-class {
    margin-top: 4px;
    font-weight: 700;
  }
  .substudentItem-area {
    flex: 1;
    margin-left: 5px;
    padding-top: 28px;
    border-bottom: 1px solid var(--card-color);
    color: var(--card-color);
  }
}
</style>
